import { render } from "./FellowshipForm.vue?vue&type=template&id=3adfe70d&scoped=true"
import script from "./FellowshipForm.vue?vue&type=script&lang=js"
export * from "./FellowshipForm.vue?vue&type=script&lang=js"

import "./FellowshipForm.vue?vue&type=style&index=0&id=3adfe70d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adfe70d"]])

export default __exports__